// Languages the Controller has translations for (see common/i18n).
export const SUPPORTED_LANGUAGES = ["en", "fr", "es", "it"];

/**
 * Normalise a language code from the API (e.g. "fr", "fr-ca", "EN") to one the
 * Controller supports, or null if it isn't one we can show.
 */
export const resolveLanguageCode = (code) => {
    const base = String(code ?? "")
        .toLowerCase()
        .split(/[-_]/)[0];
    return SUPPORTED_LANGUAGES.includes(base) ? base : null;
};

/** The i18n resource key for a language code ("en" is stored as "enGb"). */
export const i18nKeyForLanguage = (code) => (code === "en" ? "enGb" : code);
